import React from 'react';
import { Link } from 'react-router-dom';
import { HeaderWrapper, MoviePickerLogo, NoAvatarImg } from './NavbarStyles';
import moviePickerLogo from '../../imgs/svgs/moviePickerLogo.svg';
import noAvatar from '../../imgs/svgs/noAvatar.svg';
import { useAuth0 } from '@auth0/auth0-react';
const NavBar = () => {
  const { isAuthenticated, loginWithRedirect, logout, user } = useAuth0();
  return (
    <HeaderWrapper>
      <header>
        <Link to='/'>
          <MoviePickerLogo src={moviePickerLogo} alt='MOVIEPICKER' />
        </Link>
        <div>
          {isAuthenticated && (
            <>
              <Link to='/my-list' title='My list`'>
                {user.nickname.toUpperCase()}'S LIST
              </Link>
              <button
                className='loginBtn'
                onClick={() => logout({ returnTo: window.location.origin })}
              >
                Logout
              </button>
            </>
          )}

          {isAuthenticated || (
            <>
              <button className='loginBtn' onClick={loginWithRedirect}>
                Login
              </button>{' '}
              |
              <button className='loginBtn' onClick={loginWithRedirect}>
                Sign up
              </button>
            </>
          )}
          {isAuthenticated && (
            <NoAvatarImg
              src={user.picture ? user.picture : noAvatar}
              alt={`Welcome ${user.nickname}`}
            />
          )}
        </div>
      </header>
    </HeaderWrapper>
  );
};

export default NavBar;
